import { Box, Typography, Paper, Container } from '@mui/material';

export default function PortalPage() {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4 }}>
        <Typography variant="h4" gutterBottom>
          Customer Portal
        </Typography>
        <Paper sx={{ p: 3, minHeight: 600, mt: 2 }}>
          <Typography color="text.secondary">
            Customer portal for ticket submission and tracking will be displayed here
          </Typography>
        </Paper>
      </Box>
    </Container>
  );
}
